/**
 * Stylized success card mirroring the existing Lincoln Method "Success
 * Stories" cards — colored background, name top-right, before/after bar
 * chart, placeholder silhouette where a real student photo would go.
 */
export default function StudentSuccessCard({ name, sessions, topic, before, after, bg, accent = 'light' }) {
  const textColor = accent === 'light' ? '#fff' : 'var(--ink)';
  return (
    <div
      className="relative overflow-hidden flex flex-col justify-between"
      style={{
        borderRadius: 16,
        aspectRatio: '16/10',
        backgroundImage: `linear-gradient(135deg, ${bg} 0%, ${bg}cc 60%, ${bg}88 100%)`,
        color: textColor,
        padding: 18,
        boxShadow: 'var(--shadow-md)',
      }}
    >
      <div className="flex items-center gap-1.5 font-bold" style={{ fontSize: 11 }}>
        <span
          className="inline-flex items-center justify-center font-serif"
          style={{ width: 16, height: 16, background: '#f0b80c', borderRadius: 2, color: '#2b6cd9', fontSize: 12 }}
        >m</span>
        <span>Lincoln School</span>
      </div>

      <div className="absolute text-right" style={{ top: 18, right: 18, maxWidth: '55%' }}>
        <div className="font-serif font-semibold leading-none tracking-tight" style={{ fontSize: 26 }}>{name}</div>
        <div className="mt-1 opacity-90" style={{ fontSize: 10, letterSpacing: '0.04em' }}>took {sessions} session{sessions > 1 ? 's' : ''} in</div>
        <div className="font-bold uppercase mt-0.5" style={{ fontSize: 12, letterSpacing: '0.06em' }}>{topic}</div>
      </div>

      <div
        className="absolute flex items-end justify-center gap-3"
        style={{ right: 18, bottom: 18, width: 116, height: 78, background: '#fff', borderRadius: 8, padding: 8 }}
      >
        <div className="text-center flex flex-col items-center">
          <div className="font-bold" style={{ fontSize: 10, color: '#e23a3a', marginBottom: 2 }}>{before}%</div>
          <div style={{ width: 16, height: `${(before / 100) * 50}px`, background: '#e23a3a', borderRadius: '2px 2px 0 0' }} />
          <div className="font-semibold mt-0.5" style={{ fontSize: 8, color: '#2f3e57' }}>Before</div>
        </div>
        <div className="text-center flex flex-col items-center">
          <div className="font-bold" style={{ fontSize: 10, color: '#22b572', marginBottom: 2 }}>{after}%</div>
          <div style={{ width: 16, height: `${(after / 100) * 50}px`, background: '#22b572', borderRadius: '2px 2px 0 0' }} />
          <div className="font-semibold mt-0.5" style={{ fontSize: 8, color: '#2f3e57' }}>After</div>
        </div>
      </div>

      {/* Placeholder silhouette */}
      <div
        className="absolute flex items-end justify-center"
        style={{
          left: 12,
          bottom: 0,
          width: 110,
          height: '85%',
          background: 'radial-gradient(ellipse at 50% 70%, rgba(255,255,255,0.25), transparent 70%)',
          paddingBottom: 4,
        }}
      >
        <svg viewBox="0 0 80 100" width="100%" height="100%" style={{ opacity: 0.7 }}>
          <circle cx="40" cy="30" r="18" fill="rgba(255,255,255,0.5)" />
          <path d="M10 100 Q10 60 40 56 Q70 60 70 100 Z" fill="rgba(255,255,255,0.45)" />
        </svg>
      </div>
    </div>
  );
}
